import iconTranslate from '../../../weather/translations/weatherIconTranslations'

const getWeatherCode = (weatherCode: number, isNewLayout: boolean = false, imagesDomain?: string) => {
    if (isNewLayout) {
        return `${imagesDomain || ''}/Common/images/weather-new-icons/newWeatherSvgs/${weatherCode}.svg`
    }
    return `${imagesDomain || ''}/Common/images/weather/${iconTranslate(weatherCode)}.svg`
}

export default getWeatherCode